 const GET_MY_ALERT_NOTIFICATION_DETAILS = "GET_MY_ALERT_NOTIFICATION_DETAILS";
 const SET_MY_ALERT_NOTIFICATION_DETAILS = "SET_MY_ALERT_NOTIFICATION_DETAILS";
 const GET_DELETE_ALERT_NOTIFICATION_DETAILS = "GET_DELETE_ALERT_NOTIFICATION_DETAILS";
 const SET_DELETE_ALERT_NOTIFICATION_DETAILS = "SET_DELETE_ALERT_NOTIFICATION_DETAILS";

 const GET_DELETE_ALL_NOTIFICATIONS = "GET_DELETE_ALL_NOTIFICATIONS"
 const SET_DELETE_ALL_NOTIFICATIONS = "SET_DELETE_ALL_NOTIFICATIONS"

 const GET_DELETE_ALL_ALERTS = "GET_DELETE_ALL_ALERTS"
 const SET_DELETE_ALL_ALERTS = "SET_DELETE_ALL_ALERTS"

 const SET_IS_ALERT_NOTIFICATION_API_CALLED = "SET_IS_ALERT_NOTIFICATION_API_CALLED"

export
{
    GET_MY_ALERT_NOTIFICATION_DETAILS,
    SET_MY_ALERT_NOTIFICATION_DETAILS,
    GET_DELETE_ALERT_NOTIFICATION_DETAILS,
    SET_DELETE_ALERT_NOTIFICATION_DETAILS,
    GET_DELETE_ALL_NOTIFICATIONS,
    SET_DELETE_ALL_NOTIFICATIONS,
    GET_DELETE_ALL_ALERTS,
    SET_DELETE_ALL_ALERTS,
    SET_IS_ALERT_NOTIFICATION_API_CALLED
};